/**
 * tasksense-scheduler-service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Scheduling frequency — also acts as the @JsonTypeInfo discriminator for the SchedulerDefinition polymorphic hierarchy.
 */
export const Frequency = {
    Once: 'ONCE',
    Hourly: 'HOURLY',
    Daily: 'DAILY',
    Weekly: 'WEEKLY',
    Monthly: 'MONTHLY',
    Yearly: 'YEARLY',
    Cron: 'CRON'
} as const;
export type Frequency = typeof Frequency[keyof typeof Frequency];

